import React from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';

import moment from 'moment';
import price from '~/helpers/price';

import routes from '~/apiRouter';

import Loader from '~/components/ui/Loader';
import CoursePlaybill from '~/popups/CoursePlaybill';

import cities, { onlineCityCode } from '~/data/fakeCities'; // its not fake, its real
import { filterAvailableOnlineEvents } from '~h/eventFilters';

moment.locale('ru');

export default class BlockCTA extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      city: cities.find(c => c.selected) || null,
      cities: cities || [],
      data: [],
      loading: true,
      error: null,
      opened: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  prepareData(data) {
    const cards = [];
    data = data.filter(
      c => c.SHORT_NAME && (c.CITY != null || c.CITY_CODE == onlineCityCode),
    );
    data.forEach(c => {
      if (c.START_DATE) {
        // Если один день — то заводим как одну карточку
        cards.push({
          id: `${c.CODE}`,
          dateFrom: new Date(c.START_DATE),
          productCard: false,
          ...c,
        });
      } else {
        // Постоянное мероприятие без даты старта
        cards.push({
          id: `${c.CODE}`,
          dateFrom: new Date(),
          productCard: true,
          ...c,
        });
      }
    });

    cards.sort((a, b) => {
      return a.dateFrom - b.dateFrom;
    });

    return cards;
  }

  loadData() {
    const { disciplines } = this.props;

    if (!disciplines?.length) {
      this.setState({
        data: [],
        loading: false,
      });

      return;
    }

    const headers = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    headers.credentials = 'include';
    const disciplineCodes = disciplines.length > 0 ? disciplines.join('/') : '';
    const taggedPageCode =
      this.props.pageCode || $('#page-editor').data('page_code');
    const pageCode = taggedPageCode ? `/page/${taggedPageCode}` : '';
    const url = `${routes.playbill.get}${disciplineCodes}${pageCode}`;
    fetch(url, headers)
      .then(response => response.json())
      .then(response => {
        if (response.status === 'success') {
          const newData = this.prepareData(response.data.EVENTS);

          this.setState({
            data: newData || [],
            loading: false,
          });
        } else {
          this.setState({
            error: response.errors || ['Ошибка загрузки данных расписания'],
            loading: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          error: [`Ошибка загрузки расписания с сервера: ${error.message}`],
          loading: false,
        });
      });
  }

  changeOpened(e) {
    e.preventDefault();
    const { opened } = this.state;
    this.setState({ opened: !opened });
  }

  prepareCityDrop() {
    const { city, cities } = this.state;
    const citiesHtml = cities.map(c => {
      const classes = ['town__link'];
      if (c == city) classes.push('is-active');
      return (
        <button
          key={c.id}
          className={classes.join(' ')}
          onClick={() => this.setState({ opened: false, city: c })}
        >
          {c.name}
        </button>
      );
    });

    return citiesHtml;
  }

  openPopup() {
    const { city } = this.state;
    const { disciplines, pageCode } = this.props;
    const taggedPageCode = pageCode || $('#page-editor').data('page_code');

    $.magnificPopup.close();
    setTimeout(function() {
      $.magnificPopup.open({
        items: {
          src: '#popup',
          type: 'inline',
        },

        closeOnBgClick: false,
        removalDelay: 250,
        mainClass: 'mfp-anim',
        callbacks: {
          beforeOpen() {
            this.st.mainClass = 'mfp-anim popup-info';
          },
          open() {
            render(
              <CoursePlaybill
                city={city}
                code={disciplines ? disciplines.join('/') : ''}
                pageCode={taggedPageCode}
              />,
              $('#popup')[0],
            );
          },
          close() {
            render(<div />, $('#popup')[0]);
          },
        },
      });
    }, 500);
  }

  getCurrentMorphologyCity() {
    const { city } = this.state;
    const morphologyMapping = {
      Москва: 'Москве',
      'Санкт-Петербург': 'Санкт-Петербурге',
      Казань: 'Казани',
      Екатеринбург: 'Екатеринбурге',
      Новосибирск: 'Новосибирске',
      Воронеж: 'Воронеже',
      Краснодар: 'Краснодаре',
      'Ростов-На-Дону': 'Ростове-на-Дону',
      'Другие города': 'других городах',
    };
    return morphologyMapping[city.name] || `городе ${city.name}`;
  }

  getFilteredEvent() {
    const { city, data } = this.state;
    const filteredOnlineData = filterAvailableOnlineEvents(data, city.kladr);
    let event = null;
    // Find not online event
    filteredOnlineData.forEach(e => {
      if (
        e.CITY != null &&
        e.CITY.ID === city.id &&
        event == null &&
        (e.dateFrom >= new Date() || e.productCard)
      ) {
        event = e;
      }
    });

    // If city don't have offline events, find online
    if (event == null) {
      return filteredOnlineData.find(
        e =>
          e.CITY_CODE == onlineCityCode &&
          event == null &&
          (e.dateFrom >= new Date() || e.productCard),
      );
    }

    return event;
  }

  // выводит true, если цены курсов одинаковы
  getPriceTheSame() {
    const { data } = this.state;
    let prices = []
    if (data) {
      prices = data.map(e => e.PRICE);
      prices = prices.filter(price => prices[0] !== price);
    }

    return prices.length === 0;
  }

  getMinimalPrice() {
    const { city, data } = this.state;
    const payableEvents = data
      .filter(
        event =>
          ((event.CITY && event.CITY.ID === city.id) ||
            (event.CITY_CODE === onlineCityCode &&
              (event.AVAILABILITY_IN_CITIES.length === 0 ||
                event.AVAILABILITY_IN_CITIES.includes(city.kladr)))) &&
          event.PRICE > 0 &&
          (event.dateFrom >= new Date() || event.productCard),
      )
      .sort((a, b) => {
        if (
          parseInt(a.PRICE_WITH_VAT + a.EXAM_PRICE) >
          parseInt(b.PRICE_WITH_VAT + b.EXAM_PRICE)
        ) {
          return 1;
        } else if (
          parseInt(a.PRICE_WITH_VAT + a.EXAM_PRICE) ==
          parseInt(b.PRICE_WITH_VAT + b.EXAM_PRICE)
        ) {
          return 0;
        } else {
          return -1;
        }
      });

    return {
      price: !isNaN(Number(payableEvents[0]?.EXAM_PRICE))
        ? Number(payableEvents[0]?.PRICE) + Number(payableEvents[0]?.EXAM_PRICE)
        : Number(payableEvents[0]?.PRICE),
      withVAT: payableEvents[0]?.PRICE !== payableEvents[0]?.PRICE_WITH_VAT,
    };
  }

  getEventDates(event) {
    if (event && event.productCard) {
      return ['В любое время'];
    }

    switch (true) {
      case !event:
        return [];
      case !event.END_DATE || event.START_DATE === event.END_DATE:
        return [moment(event.START_DATE).format('D MMMM')];
      case moment(event.START_DATE).format('MMMM') ===
        moment(event.END_DATE).format('MMMM'):
        if (
          moment(event.START_DATE).format('D') ===
          moment(event.END_DATE).format('D')
        ) {
          return [moment(event.START_DATE).format('D MMMM')];
        } else {
          return [
            moment(event.START_DATE).format('D'),
            moment(event.END_DATE).format('D MMMM'),
          ];
        }
      default:
        return [
          moment(event.START_DATE).format('D MMMM'),
          moment(event.END_DATE).format('D MMMM'),
        ];
    }
  }

  getEventType(event) {
    if (event && event.CITY_CODE == onlineCityCode) {
      return <span className="online-tag">online</span>;
    }
    return null;
  }

  renderErrorMessage() {
    return (
      <div className="cta__error-container">
        <div className="cta__error-icon" />
        <div className="cta__error-message">
          Ошибка блока: не установлена дисциплина. Этот блок будет скрыт от
          посетителей, если не установить связку с дисциплиной в настройках
          блока.
        </div>
      </div>
    );
  }

  render() {
    const { duration, disciplines, btnText } = this.props;
    const { loading, error, opened } = this.state;

    if (loading) return <Loader />;

    if (error) {
      const errors = error.map((e, index) => {
        return (
          <p key={`err_${index}`} className="txt txt--center txt--red">
            {e}
          </p>
        );
      });
      return (
        <div className="cta">
          <div className="cta__info">{errors}</div>
        </div>
      );
    }

    const event = this.getFilteredEvent();
    const dates = this.getEventDates(event);
    const type = this.getEventType(event);
    const minimalPrice = this.getMinimalPrice();
    const priceTheSame = this.getPriceTheSame();

    const towndropClasses = ['town'];
    if (opened) towndropClasses.push('is-open');

    const eventPrice = event
      ? minimalPrice.price
        ? `${priceTheSame ? '' : 'от '}${price(minimalPrice.price)}`
        : 'Бесплатно'
      : '—';

    const withVAT =
      minimalPrice.withVAT && eventPrice != '—' ? ' +\u00A0НДС' : '';

    return (
      <React.Fragment>
        {disciplines?.length === 0 && this.renderErrorMessage()}
        <div className="cta">
          <div className="cta__info">
            <div className="cta__info-group">
              <div className="cta__label">
                Ближайшие даты{' '}
                <div className="cta__city-container">
                  в&nbsp;
                  <a className="droplink" onClick={e => this.changeOpened(e)}>
                    {this.getCurrentMorphologyCity()}
                  </a>
                  <div className={towndropClasses.join(' ')}>
                    <div className="town__drop">{this.prepareCityDrop()}</div>
                  </div>
                </div>
              </div>
              <p className="text">
                {dates.length > 0
                  ? dates.join(' — ')
                  : `Нет доступных для регистрации`}
                {type}
              </p>
            </div>
            <div className="cta__info-group">
              {duration ? (
                <React.Fragment>
                  <p className="cta__label">Длительность</p>
                  <p className="text"> {duration}</p>
                </React.Fragment>
              ) : null}
            </div>
          </div>
          <div className="cta__action">
            <p className="cta__label">Стоимость</p>
            <p className="cta__price">
              {eventPrice}
              {withVAT}
            </p>
            <button
              className="btn btn--primary"
              onClick={() => this.openPopup()}
            >
              {btnText || 'Расписание и цены'}
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
